import { Media } from "./media";

export class ProdutosSend {

    constructor(item: ProdutosSend | void) {
        if(item instanceof Object) {
            this.id = item.id;
            this.nome = item.nome;
            this.tipo = item.tipo;
            this.desc = item.desc;
            this.media = item.media;
            this.activo = item.activo;
            this.marcasId = item.marcasId;
            this.preco = item.preco;
            this.colecao = item.colecao;
            this.carecteristicas = item.carecteristicas;
            this.ref = item.ref;
        }
    }

    id: number = -1;
    nome: string = "";
    tipo: string = "";
    desc: string = "";
    media: Media[] = [];
    activo: boolean = true;
    marcasId: number = -1;
    preco: number = 0;
    colecao: string = "";
    userId: string;
    carecteristicas: string = "";
    ref: string = "";
}

export class Produtos {

    constructor(item: Produtos | void) {
        if(item instanceof Object) {
            this.id = item.id;
            this.nome = item.nome;
            this.tipo = item.tipo;
            this.desc = item.desc;
            this.media = item.media;
            this.activo = item.activo;
            this.marcasId = item.marcasId;
            this.preco = item.preco;
            this.colecao = item.colecao;
            this.carecteristicas = item.carecteristicas;
            this.ref = item.ref;
        }
    }

    id: number = -1;
    nome: string = "";
    tipo: string = "";
    desc: string = "";
    media: string = "";
    activo: boolean = true;
    marcasId: number = -1;
    preco: number = 0;
    colecao: string = "";
    carecteristicas: string = "";
    ref: string = "";
}